import { formatDateRu, formatTimeRu } from "../../../utils/appointmentLabels";
import {
  competitionAssemblyLabel,
  competitionVenueLine,
  competitionUiState,
  clubEventTag,
} from "../../../utils/competitionUtils";
import { isCompetitionSession } from "../../../utils/clientScheduleUtils";
import { groupName } from "../../../utils/clientSessionUtils";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import SessionStatusBadge from "./SessionStatusBadge";
import s from "./clientApp.module.css";

function FactRow({ icon, label, children }) {
  return (
    <div className={s.compSheetFact}>
      <span className={s.compSheetFactIcon} aria-hidden>
        {icon}
      </span>
      <div className={s.compSheetFactText}>
        <span className={s.compSheetFactLabel}>{label}</span>
        <p>{children}</p>
      </div>
    </div>
  );
}

export default function CompetitionSheetContent({
  event,
  groups,
  pollRow,
  ui,
  onApply,
}) {
  const coverSrc = event.cover_image_url ? mediaUrl(event.cover_image_url) : null;
  const title = event.title || groupName(event, groups) || clubEventTag(event) || "Событие";
  const venue = competitionVenueLine(event);
  const assembly = competitionAssemblyLabel(event);
  const timeEnd = event.end_datetime ? formatTimeRu(event.end_datetime) : null;
  const tag = clubEventTag(event) || "Событие";
  const isCompetition = isCompetitionSession(event);
  const uiState = ui || (isCompetition ? competitionUiState(event) : null);

  return (
    <>
      <div
        className={`${s.compSheetHero} ${coverSrc ? s.compSheetHeroCover : ""}`}
        style={coverSrc ? { backgroundImage: `url(${coverSrc})` } : undefined}
      >
        <div className={s.compSheetHeroOverlay} aria-hidden />
        <div className={s.compSheetHeroGlow} aria-hidden />
        <span className={s.compSheetTag}>{tag}</span>
        <h2 className={s.compSheetTitle}>{title}</h2>
        <div className={s.compSheetWhen}>
          <strong>
            {formatDateRu(event.start_datetime, {
              weekday: "long",
              day: "numeric",
              month: "long",
            })}
          </strong>
          {event.start_datetime ? (
            <span>
              {formatTimeRu(event.start_datetime)}
              {timeEnd ? ` – ${timeEnd}` : ""}
            </span>
          ) : null}
        </div>
      </div>

      <div className={s.compSheetBody}>
        <div className={s.compSheetStatus}>
          {uiState?.label ? (
            <span
              className={`${s.homeCompetitionBadge} ${s[`homeCompetitionBadge_${uiState.badge}`] || ""}`}
            >
              {uiState.label}
            </span>
          ) : (
            <SessionStatusBadge appointment={event} pollRow={pollRow} large />
          )}
        </div>

        <div className={s.compSheetFacts}>
          {assembly ? (
            <FactRow
              label="Сбор"
              icon={
                <svg viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.75" />
                  <path d="M12 7v5l3 2" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
                </svg>
              }
            >
              {assembly}
            </FactRow>
          ) : null}

          {venue ? (
            <FactRow
              label="Площадка"
              icon={
                <svg viewBox="0 0 24 24">
                  <path
                    d="M12 21s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.75"
                  />
                  <circle cx="12" cy="10" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.75" />
                </svg>
              }
            >
              {venue}
            </FactRow>
          ) : null}

          {event.event_description ? (
            <FactRow
              label="Информация"
              icon={
                <svg viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.75" />
                  <path d="M12 10v5M12 8h.01" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
                </svg>
              }
            >
              <span className={s.compSheetMultiline}>{event.event_description}</span>
            </FactRow>
          ) : null}

          {event.contact_info ? (
            <FactRow
              label="Контакт"
              icon={
                <svg viewBox="0 0 24 24">
                  <path
                    d="M6.5 4h11A2.5 2.5 0 0 1 20 6.5v11A2.5 2.5 0 0 1 17.5 20h-11A2.5 2.5 0 0 1 4 17.5v-11A2.5 2.5 0 0 1 6.5 4Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.75"
                  />
                  <path d="M8 9h8M8 13h5" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
                </svg>
              }
            >
              {event.contact_info}
            </FactRow>
          ) : null}
        </div>

        {uiState?.hint ? <p className={s.compSheetHint}>{uiState.hint}</p> : null}

        {isCompetition && uiState?.canApply ? (
          <button
            type="button"
            className={s.compSheetApply}
            onClick={() => onApply?.(event)}
          >
            Подать заявку
          </button>
        ) : null}
      </div>
    </>
  );
}
